module.exports = __webpack_public_path__ + "img/icn3.a5cd6e38.svg";